angular.module('impactx.item').directive('ixItemTooltipLine', function ()
{
    return {
        scope: {
            item: "=",
            showNet: "=",
            showGross: "=",
            showCatalogNet: "=",
            showExtended: "=?",
            showAat: "=?",
            showControl: "=?"
        },
        restrict: 'A',
        templateUrl: 'shared/item/templates/itemtooltipline.html'
    };
});